import { Component, OnInit, Output, Input, EventEmitter } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, Validators, UntypedFormControl } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { ConfirmedValidator } from '@app/_services/confirmed.validator';
import { AccountService, InstoreService, ExcelRegion, ExcelShowroom, ExcelAssets, ExcelCreative, ExcelVendor, ExcelFloor, ExcelFloorM, ExcelLocation, ExcelUser, RoleInformations } from '@app/_services';
import { first } from 'rxjs/operators';
import { Sort } from '@angular/material/sort';
import * as moment from 'moment';
import * as XLSX from 'xlsx';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { ConfirmDialogService } from '../../confirm-dialog/confirm-dialog/confirm-dialog.service';
import { ToastrService } from 'ngx-toastr';
import { DataService } from '@app/_services';
import { ExcelService } from '@app/_services/excel.service';

@Component({
  selector: 'app-usermanagement',
  templateUrl: './usermanagement.component.html',
  styleUrls: ['./usermanagement.component.css']
})
export class UsermanagementComponent implements OnInit {

  private format = 'YYYY-MM-DD';
  @Input() startDateLabel: string;
  @Input() endDateLabel: string;
  @Input() startDateInput;
  @Input() endDateInput;
  @Output() StartEndDatesOutput = new EventEmitter();


  page = 1;
  pageSize = 10;
  pageL = 1;
  pageSizeL = 10;
  pageR = 1;
  pageSizeR = 10;
  pageS = 1;
  pageSizeS = 10;
  pageA = 1;
  pageSizeA = 10;
  pageC = 1;
  pageSizeC = 10;
  pageV = 1;
  pageSizeV = 10;
  pageF = 1;
  pageSizeF = 10;
  pageFM = 1;
  pageSizeFM = 10;

  isAddUser = true;
  isAddRegion = true;
  isAddShowroom = true;
  isAddAssets = true;
  isAddCreative = true;
  isAddVendor = true;
  isAddFloor = true;
  isShowAddFloor = true;
  isAddMapFloor = true;
  isAddCampaign = true;
  isAddLocation = true;
  isShowAddLocation = false;
  isShowAddCampaign = false;

  filterform: UntypedFormGroup;
  campaignFilterForm: UntypedFormGroup;
  regionForm: UntypedFormGroup;
  registerForm: UntypedFormGroup;
  updateForm: UntypedFormGroup;
  showroomForm: UntypedFormGroup;
  assetsForm: UntypedFormGroup;
  creativeForm: UntypedFormGroup;
  vendorForm: UntypedFormGroup;
  floorForm: UntypedFormGroup;
  floorMappingForm: UntypedFormGroup;
  locationForm: UntypedFormGroup;
  locationMappingForm: UntypedFormGroup;
  campaignForm: UntypedFormGroup;
  campaignMappingForm: UntypedFormGroup;

  closeResult = '';
  type;
  isAdminRole: boolean = false;
  isViewChecked = false;
  user_id: number = 0;
  user_role_id: number = 0;
  user_region_id: number = 0;
  user_Showroom_id: number = 0;
  isAdmin: boolean = false;
  isView_ = false;
  is_user_admin: boolean = false;
  start_date = new UntypedFormControl();
  minDate: any;

  selectedDesignationValue = ""
  selected_User_Region = ""
  selected_User_Showroom = ""
  selected_User_Floor = ""

  default_region_txt = "Select Region"
  default_showroom_txt = "Select Showroom"

  Festival = [{ name: "Silver Campaign", start_date: '05-02-2021', end_date: '03-03-2021', state: 'Chennai', showroom: 'Velachery', category: 'Category 1' },
  { name: "Gold Campaign", start_date: '05-03-2021', end_date: '03-04-2021', state: 'Karnataka', showroom: 'Mysore', category: 'Category 2' },
  { name: "Platinum Campaign", start_date: '05-04-2021', end_date: '03-05-2021', state: 'Andra Pradesh', showroom: 'Guntur', category: 'Category 3' }];

  constructor(private formBuilder: UntypedFormBuilder, private instoreService: InstoreService,
    private route: ActivatedRoute, private modalService: NgbModal, private confirmDialogService: ConfirmDialogService, private excelService: ExcelService,
    private router: Router, private accountService: AccountService, private toastr: ToastrService, private dataService: DataService,
  ) {
  }


  ngOnInit(): void {
    var userdata = localStorage.getItem('userInformation');
    var parsedUserData = JSON.parse(userdata);
    if (parsedUserData) {
      this.user_role_id = parsedUserData.role_id;
      if (this.user_role_id == 1 || this.user_role_id == 2) {
        this.is_user_admin = true;
      }
      this.user_id = parsedUserData.id;
      this.user_region_id = parsedUserData.region_id;
      this.user_Showroom_id = parsedUserData.showroom_id;
    }

    this.filterform = this.formBuilder.group({
      floor_id: [''],
      region_id: [''],
      showroom_id: ['']
    });
    this.campaignFilterForm = this.formBuilder.group({
      region_id: [''],
      showroom_id: ['']
    });


    this.registerForm = this.formBuilder.group({
      isView: [''],
      firstName: ['', Validators.required],
      lastName: ['', Validators.required],
      email: ['', [Validators.required, Validators.email]],
      mobile: ['', [Validators.required, Validators.pattern(this.mobNumberPattern)]],
      password: ['', [Validators.minLength(6), this.isAddUser ? Validators.required : Validators.nullValidator]],
      confirmPassword: ['', this.isAddUser ? Validators.required : Validators.nullValidator],
      role_id: ['', Validators.required],
      region_id: ['', [Validators.required]],
      showroom_id: ['', Validators.required], image: ['']
    }, {
      validator: ConfirmedValidator('password', 'confirmPassword')
    });

    this.updateForm = this.formBuilder.group({
      isView: [''],
      firstName: ['', Validators.required],
      lastName: ['', Validators.required],
      email: ['', [Validators.required, Validators.email]],
      mobile: ['', [Validators.required, Validators.pattern(this.mobNumberPattern)]],
      password: ['', [Validators.minLength(6)]],
      confirmPassword: [''],
      role_id: ['', Validators.required],
      region_id: ['', [Validators.required]],
      showroom_id: ['', Validators.required], image: ['']
    }, {
      validator: ConfirmedValidator('password', 'confirmPassword')
    });

    this.regionForm = this.formBuilder.group({
      name: ['', [Validators.minLength(3), Validators.required]],
      image: ['']
    });
    this.showroomForm = this.formBuilder.group({
      regionId: [null, [Validators.required]],
      showroomName: ['', [Validators.minLength(3), Validators.required]], image: ['']
    });
    this.assetsForm = this.formBuilder.group({
      name: ['', [Validators.minLength(3), Validators.required]],
    });
    this.creativeForm = this.formBuilder.group({
      name: ['', [Validators.minLength(2), Validators.required]],
    });
    this.vendorForm = this.formBuilder.group({
      name: ['', [Validators.minLength(3), Validators.required]],
    });
    this.floorForm = this.formBuilder.group({
      name: ['', [Validators.minLength(3), Validators.required]],
    });
    this.locationForm = this.formBuilder.group({
      name: ['', [Validators.minLength(3), Validators.required]],
    });

    this.floorMappingForm = this.formBuilder.group({
      region_id: ['', [Validators.required]],
      showroom_id: ['', [Validators.required]],
      // floor_id: ['', [ Validators.required]],
    });

    this.locationMappingForm = this.formBuilder.group({
      region_id: ['', [Validators.required]],
      showroom_id: ['', [Validators.required]],
      floor_id: ['', [Validators.required]]

    });

    this.campaignForm = this.formBuilder.group({
      name: ['', [Validators.minLength(3), Validators.required]],
      start_date: ['', [Validators.required]],
      end_date: ['', [Validators.required]],

    });
    this.campaignMappingForm = this.formBuilder.group({
      region_id: ['', [Validators.required]],
      showroom_id: ['', [Validators.required]],
    });

    this.reloadUserLists();
    this.reloadRegionLists();
    this.reloadShowroomLists();
    this.reloadAssetsLists();
    this.reloadCreativeLists();
    this.reloadVendorLists();
    this.reloadAllFloorLists();
    this.reloadLocationLists();
    this.userRoleLists();
    this.getFloorMappingLists();
    //this.reloadCampaignLists();
    this.onReset();

  }

  isLoading = false;
  RoleDataLists;
  LoggedUser;
  userRoleLists() {
    this.accountService.getUserRoleLists()
      .pipe(first())
      .subscribe(
        (response) => {
          this.isLoading = false;
          this.RoleDataLists = response.result;
          var userdata = localStorage.getItem('userInformation');
          var parsedUserData = JSON.parse(userdata);
          this.LoggedUser = parsedUserData;
          for (var i = 0; i < this.RoleDataLists.length; i++) {
            if ((this.RoleDataLists[i].id >= parsedUserData.role_id)) {
              this.RoleDataLists[i].isEnabled = true;
            } else {
              this.RoleDataLists[i].isEnabled = false;
            }
          }

        },
        (error) => {
          this.isLoading = false;
        }
      );
    this.onReset();
  }



  /* *************  USER  ************* */


  UserDataLists = [];
  sortedUserData = [];
  UpdateUserData;

  submitted = false;

  mobNumberPattern = "^((\\+91-?)|0)?[0-9]{10}$";

  get formR() { return this.registerForm.controls; }
  get formU() { return this.updateForm.controls; }


  profileImage: string;
  onProfileFileChange(event) {

    const max_size = 100000;
    const allowed_types = ['image/png', 'image/jpeg', 'image/jpg'];


    const reader = new FileReader();
    const file: File = event.target.files[0];

    if (file.size > max_size) {
      alert("Image Size should not exceed more than 100 KB")
      return false;
    }


    if (event.target.files && event.target.files.length) {
      const [file] = event.target.files;
      reader.readAsDataURL(file);
      reader.onload = () => {
        this.profileImage = reader.result as string;
        this.registerForm.get('image').setValue(event.target.files[0]);
        this.updateForm.get('image').setValue(event.target.files[0]);
      };

    }
  }
  onUserUpdate() {
    this.submitted = true;

    if (!this.updateForm.valid) {
      return;
    }
    const formDataNew = new FormData();
    formDataNew.append('userId', this.UpdateUserData.id);
    formDataNew.append('first_name', this.updateForm.get('firstName').value);
    formDataNew.append('last_name', this.updateForm.get('lastName').value);
    formDataNew.append('mobile', this.updateForm.get('mobile').value);
    formDataNew.append('password', this.updateForm.get('confirmPassword').value);
    formDataNew.append('email', this.updateForm.get('email').value);
    formDataNew.append('role_id', this.updateForm.get('role_id').value);
    formDataNew.append('profile_picture', this.updateForm.get('image').value);


    if (this.updateForm.get('role_id').value == 1 || this.updateForm.get('role_id').value == 2) {
      formDataNew.append('region_id', "0");
      formDataNew.append('showroom_id', "0");
      if (this.isView_) {
        formDataNew.append('is_view', "1");
      } else {
        formDataNew.append('is_view', "0");
      }
    } else {
      formDataNew.append('region_id', this.updateForm.get('region_id').value);
      formDataNew.append('showroom_id', this.updateForm.get('showroom_id').value);
      formDataNew.append('is_view', "0");
    }


    this.isLoading = true;
    this.accountService.updateUserData(formDataNew)
      .pipe(first())
      .subscribe(
        (response) => {
          console.log(" - form- - " + JSON.stringify(response))
          if (response.state == "SUCCESS") {
            this.isLoading = false;
            this.reloadUserLists();
            this.toastr.success(response.message, "success", { timeOut: 1000 });
          } else {
            this.isLoading = false;
            this.reloadUserLists();
            this.toastr.error(response.message, "error", { timeOut: 1000 });
          }
        },
        (error) => {
          this.isLoading = false;
        }
      );
    this.isAddUser = true;
  }
  onRegisterSubmit() {
    this.submitted = true;

    if (!this.registerForm.valid) {
      return;
    }

    if (this.isAddUser) {
      this.isLoading = true;

      const formDataNew = new FormData();
      if (this.registerForm.get('role_id').value == 1||this.registerForm.get('role_id').value == 2) {
        formDataNew.append('region_id', "0");
        formDataNew.append('showroom_id', "0");
        if (this.isViewChecked) {
          formDataNew.append('is_view', "1");
        } else {
          formDataNew.append('is_view', "0");
        }
      } else {
        formDataNew.append('region_id', this.registerForm.get('region_id').value);
        formDataNew.append('showroom_id', this.registerForm.get('showroom_id').value);
        formDataNew.append('is_view', "0");
      }
      formDataNew.append('first_name', this.registerForm.get('firstName').value);
      formDataNew.append('last_name', this.registerForm.get('lastName').value);
      formDataNew.append('mobile', this.registerForm.get('mobile').value);
      formDataNew.append('password', this.registerForm.get('confirmPassword').value);
      formDataNew.append('email', this.registerForm.get('email').value);
      formDataNew.append('role_id', this.registerForm.get('role_id').value);
      formDataNew.append('profile_picture', this.registerForm.get('image').value);

      this.accountService.addUserData(formDataNew)
        .pipe(first())
        .subscribe(
          (response) => {
            console.log(response)
            if (response.state == "ERROR") {
              this.isLoading = false;
              this.reloadUserLists();
              this.toastr.error(response.message, "error", { timeOut: 1000 });
            }
            else {
              this.isLoading = false;
              this.reloadUserLists();
              this.toastr.success(response.message, "success", { timeOut: 1000 });
            }

          },
          (error) => {
            console.log(error)
            this.isLoading = false;
          }
        );
    }

  }


  reloadUserLists() {
    this.isLoading = true;

    this.accountService.getUserLists()
      .pipe(first())
      .subscribe(
        (response) => {
          this.isLoading = false;
          this.UserDataLists = response.result;
          this.sortedUserData = response.result
          this.isAddUser = true;
        },
        (error) => {
          this.isLoading = false;
        }
      );
    this.onReset();
  }



  editUser(userInfo: any, id: number) {
    console.log("yes");
    this.registerForm.reset();
    if (userInfo.role_id == 2) {
      this.resetUserForm();
      this.isAdmin = true;
      if (userInfo.is_view == 1) {
        this.isView_ = true
      } else {
        this.isView_ = false;
      }

    } else {
      this.updateForm.get('region_id').enable();
      this.updateForm.get('showroom_id').enable();
      this.default_region_txt = "Select Region"
      this.default_showroom_txt = "Select Showroom"
      this.isAdmin = false;
      this.isView_ = false;
    }



    this.isAddUser = false;
    this.UpdateUserData = this.UserDataLists.find(x => x.id === id);
    this.updateForm.controls.firstName.setValue(this.UpdateUserData.first_name);
    this.updateForm.controls.lastName.setValue(this.UpdateUserData.last_name);
    this.updateForm.controls.email.setValue(this.UpdateUserData.email);
    this.updateForm.controls.mobile.setValue(this.UpdateUserData.mobile);

    if (this.UpdateUserData.region_id > 0) {
      this.updateForm.controls.region_id.setValue(this.UpdateUserData.region_id);
    }
    this.updateForm.get('email').disable();

    this.profileImage = "https://brandmonitoringapp.grtjewels.com/api/uploads/" + this.UpdateUserData.profile_picture;
    // this.registerForm.controls.showroom_id.setValue(this.UpdateUserData.showroom_id);
    this.updateForm.controls.role_id.setValue(this.UpdateUserData.role_id);
    this.onUserRegionChange(this.UpdateUserData.region_id, false, this.UpdateUserData.showroom_id)

  }
  suspendUser(id: string, name: string, isSuspended: number) {
    var is_suspend;
    var _text = "";
    if (isSuspended == 1) {
      is_suspend = 0;
      _text = "unsuspend"
    } else {
      is_suspend = 1;
      _text = "suspend"
    }
    this.confirmDialogService.confirmThis('Are you sure you want to ' + _text + ' ' + name + '?', () => {

      this.isLoading = true;
      this.accountService.suspendUser(id, is_suspend)
        .pipe(first())
        .subscribe(
          (response) => {
            //console.log(JSON.stringify(response))
            this.isLoading = false;
            this.reloadUserLists();
          },
          (error) => {
            //console.log(JSON.stringify(error))
            this.isLoading = false;
          }
        );
    }, () => {

    });

  }

  sortData(sort: Sort) {
    const data = this.UserDataLists.slice();
    if (!sort.active || sort.direction == '') {
      this.sortedUserData = data;
      return;
    }

    this.sortedUserData = data.sort((a, b) => {
      let isAsc = sort.direction == 'asc';
      switch (sort.active) {
        case 'first_name': return this.accountService.compare(a.first_name, b.first_name, isAsc);
        case 'role_id': return this.accountService.compare(a.role_id, b.role_id, isAsc);
        case 'region_id': return this.accountService.compare(a.region_id, b.region_id, isAsc);
        case 'showroom_id': return this.accountService.compare(a.showroom_id, b.showroom_id, isAsc);
        case 'is_suspended': return this.accountService.compare(a.is_suspended, b.is_suspended, isAsc);
        default: return 0;
      }
    });
  }
  addNewUser() {
    this.onReset();
    this.isAddUser = true;

  }


  /* *************  USER  ************* */




  /* *************  REGION  ************* */
  RegionDataLists;
  sortedRegionData;
  UpdateRegionData;
  imageSrc: string;


  onRegionFileChange(event) {

    const max_size = 100000;
    const allowed_types = ['image/png', 'image/jpeg', 'image/jpg'];


    const reader = new FileReader();
    const file: File = event.target.files[0];

    if (file.size > max_size) {
      alert("Image Size should not exceed more than 100 KB")
      return false;
    }


    if (event.target.files && event.target.files.length) {
      const [file] = event.target.files;
      reader.readAsDataURL(file);
      reader.onload = () => {
        this.imageSrc = reader.result as string;
        this.regionForm.get('image').setValue(event.target.files[0]);
      };

    }
  }

  r_regionImage() {
    // alert("remove image")
  }

  regionSubmitted = false;
  get f1() { return this.regionForm.controls; }

  onRegionSubmit() {
    this.regionSubmitted = true;
    var strRegionName = this.regionForm.get('name').value.trim();
    if (this.regionForm.invalid) {
      return;
    }
    if (this.isAddRegion) {
      this.isLoading = true;
      const formDataNew = new FormData();
      formDataNew.append('name', strRegionName);
      formDataNew.append('image', this.regionForm.get('image').value);

      this.accountService.addRegion(formDataNew)
        .pipe(first())
        .subscribe(
          (response) => {
            this.isLoading = false;
            if (response.state === "ERROR") {
              this.toastr.error("The region " + strRegionName + " already exists", "Error", { timeOut: 1000 });
            } else {
              this.toastr.success("The region " + strRegionName + " added successfully", "Success", { timeOut: 1000 });
              this.reloadRegionLists();
            }
          },
          (error) => {
            this.isLoading = false;
          }
        );
    } else {
      this.isLoading = true;
      const formDataNew = new FormData();

      formDataNew.append('region_id', this.UpdateRegionData.id);
      formDataNew.append('name', strRegionName);
      formDataNew.append('image', this.regionForm.get('image').value);

      this.accountService.updateRegion(formDataNew)
        .pipe(first())
        .subscribe(
          (response) => {
            this.isLoading = false;
            if (response.state === "ERROR") {
              this.toastr.error("The region " + strRegionName + " already exists", "Error", { timeOut: 1000 });
            } else {
              this.toastr.success("The region " + strRegionName + " updated successfully", "Success", { timeOut: 1000 });
              this.reloadRegionLists();
            }
          },
          (error) => {
            this.isLoading = false;
          }
        );
      this.isAddRegion = true;
    }
  }

  reloadRegionLists() {
    this.accountService.getRegionsLists()
      .pipe(first())
      .subscribe(
        (response) => {
          this.isLoading = false;
          this.RegionDataLists = response.result;
          this.sortedRegionData = this.RegionDataLists.slice();

          console.log("---------" + JSON.stringify(this.sortedRegionData));
        },
        (error) => {
          this.isLoading = false;
        }
      );
    this.onReset();
  }

  editRegion(id: string) {
    this.onReset();
    this.isAddRegion = false;
    this.UpdateRegionData = this.RegionDataLists.find(x => x.id === id);
    this.regionForm.controls.name.setValue(this.UpdateRegionData.name);
    if (this.UpdateRegionData.image == null) {
      this.imageSrc = "";
      return;
    }
    this.imageSrc = "https://brandmonitoringapp.grtjewels.com/api/uploads/" + this.UpdateRegionData.image;
  }

  sortRegionData(sort: Sort) {
    const data = this.RegionDataLists.slice();
    if (!sort.active || sort.direction == '') {
      this.sortedRegionData = data;
      return;
    }

    this.sortedRegionData = data.sort((a, b) => {
      let isAsc = sort.direction == 'asc';
      switch (sort.active) {
        case 'name': return this.accountService.compare(a.name, b.name, isAsc);
        case 'is_suspended': return this.accountService.compare(a.is_suspended, b.is_suspended, isAsc);
        default: return 0;
      }
    });
  }

  addNewRegion() {
    this.onReset();
    this.isAddRegion = true;
  }

  suspendRegion(id: string, name: string, isSuspended: number) {
    var is_suspended;
    var _text = "";
    if (isSuspended == 1) {
      is_suspended = 0;
      _text = "unsuspend"
    } else {
      is_suspended = 1;
      _text = "suspend"
    }
    this.confirmDialogService.confirmThis('Are you sure you want to ' + _text + ' ' + name + '?', () => {

      this.isLoading = true;
      this.accountService.suspendRegion(id, is_suspended)
        .pipe(first())
        .subscribe(
          (response) => {
            this.isLoading = false;
            this.reloadRegionLists();
            this.reloadShowroomLists();
          },
          (error) => {
            this.isLoading = false;
          }
        );
    }, () => {

    });
  }
  deleteRegion(id: string, name: string) {
    this.confirmDialogService.confirmThis('Are you sure you want to delete the region ' + name + '?. All showrooms respective to ' + name + ' along with Instore and Hoarding will get deleted also the Instore and hoardings. Please make sure !'


      , () => {

        this.isLoading = true;
        this.accountService.deleteRegion(id, 1)
          .pipe(first())
          .subscribe(
            (response) => {
              this.isLoading = false;
              this.reloadRegionLists();
              this.reloadShowroomLists();
            },
            (error) => {
              this.isLoading = false;
            }
          );
      }, () => {

      });

  }

  selRegionValue: number;
  f_user_ShowroomLists;


  onUserRoleChange(roleID) {
    if (roleID == 2 || roleID == 1) {
      this.registerForm.get('region_id').disable();
      this.registerForm.get('showroom_id').disable();
      this.default_region_txt = "All Region"
      this.default_showroom_txt = "All Showroom"
      this.isAdmin = true;
    } else {
      this.registerForm.get('region_id').enable();
      this.registerForm.get('showroom_id').enable();
      this.default_region_txt = "Select Region"
      this.default_showroom_txt = "Select Showroom"
      this.isAdmin = false;
      this.isViewChecked = false;
    }
    this.resetUserForm()
  }


  onUserRoleUpdate(roleID) {
    this.resetUserForm();
    if (roleID == 2) {
      this.updateForm.get('region_id').disable();
      this.updateForm.get('showroom_id').disable();
      this.default_region_txt = "All Region"
      this.default_showroom_txt = "All Showroom"
      this.isAdmin = true;
    } else {
      this.updateForm.get('region_id').enable();
      this.updateForm.get('showroom_id').enable();
      this.default_region_txt = "Select Region"
      this.default_showroom_txt = "Select Showroom"
      this.isAdmin = false;
    }
  }


  onUserRegionChange(regionValue, isAdd: boolean, showroom_id) {

    this.resetShowroom()
    let selectedRegionValue = parseInt(regionValue, 10);
    if (selectedRegionValue > 0) {
      this.f_user_ShowroomLists = this.ShowroomDataLists.filter(s => s.region_id === selectedRegionValue);
    }
    else {
      this.default_region_txt = "All Region"
      this.updateForm.get('region_id').disable();
      this.updateForm.get('showroom_id').disable();
      this.default_showroom_txt = "All Showroom"
    }
    if (!isAdd) {
      var selShowroomValue: number = showroom_id;
      if (selShowroomValue > 0) {
        this.updateForm.controls.showroom_id.setValue(this.f_user_ShowroomLists.filter(s => s.id === selShowroomValue)[0].id);
      }

    }
  }


  onRegionChange(regionValue, isAdd: boolean, showroom_id) {
    this.resetShowroom()
    this.locationRegionID = regionValue;
    this.selRegionValue = parseInt(regionValue, 10);
    this.f_user_ShowroomLists = this.ShowroomDataLists.filter(s => s.region_id === this.selRegionValue);

  }


  resetUserForm() {
    this.registerForm.patchValue({
      region_id: ''
    });
    this.registerForm.patchValue({
      showroom_id: ''
    });

    this.updateForm.patchValue({
      region_id: ''
    });
    this.updateForm.patchValue({
      showroom_id: ''
    });
  }


  resetShowroom() {
    this.regionForm.patchValue({
      showroom_id: ''
    });
    this.updateForm.patchValue({
      showroom_id: ''
    });
  }




  /* *************  REGION  ************* */




  /* *************  SHOWROOM  ************* */
  ShowroomDataLists;
  sortedShowroomData;
  UpdateShowroomData;
  // regionList;

  showroomSubmitted = false;
  get f2() { return this.showroomForm.controls; }
  imageShowroomSrc: string;
  onShowroomFileChange(event) {

    const max_size = 100000;
    const allowed_types = ['image/png', 'image/jpeg', 'image/jpg'];
    const reader = new FileReader();
    const file: File = event.target.files[0];

    if (file.size > max_size) {
      alert("Image Size should not exceed more than 100 KB")
      return false;
    }

    if (event.target.files && event.target.files.length) {
      const [file] = event.target.files;
      reader.readAsDataURL(file);
      reader.onload = () => {
        this.imageShowroomSrc = reader.result as string;
        this.showroomForm.get('image').setValue(event.target.files[0]);
      };

    }
  }


  onShowroomSubmit() {
    this.showroomSubmitted = true;
    var strShowroomName = this.showroomForm.get('showroomName').value;
    if (this.showroomForm.invalid) {
      return;
    }
    if (this.isAddShowroom) {
      this.isLoading = true;

      const formDataNew = new FormData();

      formDataNew.append('region_id', this.showroomForm.get('regionId').value);
      formDataNew.append('name', strShowroomName);
      formDataNew.append('image', this.showroomForm.get('image').value);


      this.accountService.addShowroom(formDataNew)
        .pipe(first())
        .subscribe(
          (response) => {
            this.isLoading = false;

            if (response.state === "ERROR") {
              this.toastr.error("The showroom " + strShowroomName + " already exists", "Error", { timeOut: 1000 });
            } else {
              this.toastr.success("The showroom " + strShowroomName + " added successfully", "Success", { timeOut: 1000 });
              this.reloadShowroomLists();
            }
          },
          (error) => {
            this.isLoading = false;
          }
        );
    } else {
      this.isLoading = true;

      const formDataNew = new FormData();
      formDataNew.append('showroom_id', this.UpdateShowroomData.id);
      formDataNew.append('region_id', this.showroomForm.get('regionId').value);
      formDataNew.append('name', strShowroomName);
      formDataNew.append('image', this.showroomForm.get('image').value);


      this.accountService.updateShowroom(formDataNew)
        .pipe(first())
        .subscribe(
          (response) => {
            this.isLoading = false;
            if (response.state === "ERROR") {
              this.toastr.error("The showroom " + strShowroomName + " already exists", "Error", { timeOut: 1000 });
            } else {
              this.toastr.success("The showroom " + strShowroomName + " updated successfully", "Success", { timeOut: 1000 });
              this.reloadShowroomLists();
            }
          },
          (error) => {
            this.isLoading = false;
          }
        );
      this.isAddShowroom = true;
    }
  }

  reloadShowroomLists() {
    this.accountService.getShowroomLists()
      .pipe(first())
      .subscribe(
        (response) => {
          this.isLoading = false;
          this.ShowroomDataLists = response.result;
          this.sortedShowroomData = this.ShowroomDataLists.slice();
        },
        (error) => {
          this.isLoading = false;
        }
      );
    this.onReset();
  }

  editShowroom(id: string) {
    this.showroomForm.reset();
    this.isAddShowroom = false;
    this.UpdateShowroomData = this.ShowroomDataLists.find(x => x.id === id);
    this.showroomForm.controls.showroomName.setValue(this.UpdateShowroomData.name);
    this.showroomForm.controls.regionId.setValue(this.UpdateShowroomData.region_id);
    if (this.UpdateShowroomData.image == null) {
      this.imageShowroomSrc = "";
      return;
    }


    this.imageShowroomSrc = "https://brandmonitoringapp.grtjewels.com/api/uploads/" + this.UpdateShowroomData.image;
  }

  sortShowroomData(sort: Sort) {
    const data = this.ShowroomDataLists.slice();
    if (!sort.active || sort.direction == '') {
      this.sortedShowroomData = data;
      return;
    }

    this.sortedShowroomData = data.sort((a, b) => {
      let isAsc = sort.direction == 'asc';
      switch (sort.active) {
        case 'name': return this.accountService.compare(a.name, b.name, isAsc);
        case 'regionName': return this.accountService.compare(a.regionName, b.regionName, isAsc);
        case 'is_suspended': return this.accountService.compare(a.is_suspended, b.is_suspended, isAsc);
        default: return 0;
      }
    });
  }

  suspendShowroom(id: string, name: string, isSuspended: number) {
    var is_suspended;
    var _text = "";
    if (isSuspended == 1) {
      is_suspended = 0;
      _text = "unsuspend"
    } else {
      is_suspended = 1;
      _text = "suspend"
    }
    this.confirmDialogService.confirmThis('Are you sure you want to ' + _text + ' ' + name + '?', () => {

      this.isLoading = true;
      this.accountService.suspendShowroom(id, is_suspended)
        .pipe(first())
        .subscribe(
          (response) => {
            this.isLoading = false;
            this.reloadShowroomLists();
          },
          (error) => {
            this.isLoading = false;
          }
        );
    }, () => {

    });
  }

  deleteShowroom(id: string, name: string) {

    this.confirmDialogService.confirmThis('Are you sure you want to delete the showroom ' + name + '?. On deleting the showroom all Instore and Hoarding belongs to ' + name + ' will also get deleted', () => {

      this.isLoading = true;
      this.accountService.deleteShowroom(id, 1)
        .pipe(first())
        .subscribe(
          (response) => {
            this.isLoading = false;
            this.reloadShowroomLists();
            this.getFloorMappingLists();
          },
          (error) => {
            this.isLoading = false;
          }
        );
    }, () => {

    });



  }

  deleteUser(user: any) {

    this.confirmDialogService.confirmThis('Are you sure you want to delete the user ' + name + '?', () => {

      this.isLoading = true;
      this.accountService.deleteUser(user)
        .pipe(first())
        .subscribe(
          (response) => {
            if (response.state == "SUCCESS") {
              this.toastr.success(response.message, "Success", { timeOut: 1000 });
            } else {
              this.toastr.error(response.message, "Error", { timeOut: 1000 });
            }
            this.userRoleLists();
            this.reloadUserLists();
            this.isLoading = false;
          },
          (error) => {
            this.isLoading = false;
            // this.toastr.warning(response.data, "Warning", {timeOut: 1000});
          }
        );
    }, () => {

    });



  }
  selShowroomValue: number;
  ShowroomFloorDataLists
  onShowroomChange(ShowroomValue) {
    this.selShowroomValue = parseInt(ShowroomValue, 10);
  }
  getFloorfromShowroom(ShowroomValue) {
    // this.selShowroomValue =  parseInt(ShowroomValue, 10);
    this.locationShowroomID = ShowroomValue;
    this.resetFloor()
    this.callShowroomFloorLists(parseInt(ShowroomValue, 10))
  };


  callShowroomFloorLists(showroomID) {
    this.instoreService.getFloorLists(showroomID)
      .pipe(first())
      .subscribe(
        (response) => {
          this.isLoading = false;
          this.ShowroomFloorDataLists = response.result;
          //console.log("---"+JSON.stringify(this.ShowroomFloorDataLists));

        },
        (error) => {
          this.isLoading = false;
        }
      );
  }

  resetFloor() {
    this.ShowroomFloorDataLists = [];
    this.locationMappingForm.patchValue({
      floor_id: ''
    });
  }
  addNewShowroom() {
    this.onReset();
    this.isAddShowroom = true;
  }

  /* *************  SHOWROOM  ************* */


  /* *************  ASSETS  ************* */

  AssetsDataLists;
  sortedAssetsData;
  UpdateAssetsData;

  assetsSubmitted = false;
  get f3() { return this.assetsForm.controls; }

  onAssetsSubmit() {
    this.assetsSubmitted = true;
    var str_Asset = this.f3.name.value.trim();
    if (this.assetsForm.invalid) {
      return;
    }
    if (this.isAddAssets) {
      this.accountService.addAssets(str_Asset)
        .pipe(first())
        .subscribe(
          (response) => {
            this.isLoading = false;
            if (response.state === "ERROR") {
              this.toastr.error("The asset type " + str_Asset + " already exists", "Error", { timeOut: 1000 });
            } else {
              this.toastr.success("The asset type " + str_Asset + " added successfully", "Success", { timeOut: 1000 });
              this.reloadAssetsLists();
            }
          },
          (error) => {
            this.isLoading = false;
          }
        );
    } else {
      this.isLoading = true;
      this.accountService.updateAssets(this.UpdateAssetsData.id, str_Asset)
        .pipe(first())
        .subscribe(
          (response) => {
            this.isLoading = false;
            if (response.state === "ERROR") {
              this.toastr.error("The asset type " + str_Asset + " already exists", "Error", { timeOut: 1000 });
            } else {
              this.toastr.success("The asset type " + str_Asset + " added successfully", "Success", { timeOut: 1000 });
              this.reloadAssetsLists();
            }
          },
          (error) => {
            this.isLoading = false;
          }
        );
      this.isAddAssets = true;
    }
  }

  reloadAssetsLists() {
    this.accountService.getAssetsLists()
      .pipe(first())
      .subscribe(
        (response) => {
          this.isLoading = false;
          this.AssetsDataLists = response.result;
          this.sortedAssetsData = response.result;
        },
        (error) => {
          this.isLoading = false;
        }
      );
    this.onReset();
  }

  editAssets(id: string) {
    this.assetsForm.reset();
    this.isAddAssets = false;
    this.UpdateAssetsData = this.AssetsDataLists.find(x => x.id === id);
    this.assetsForm.controls.name.setValue(this.UpdateAssetsData.name);
  }

  sortAssetsData(sort: Sort) {
    const data = this.AssetsDataLists.slice();
    if (!sort.active || sort.direction == '') {
      this.sortedAssetsData = data;
      return;
    }

    this.sortedAssetsData = data.sort((a, b) => {
      let isAsc = sort.direction == 'asc';
      switch (sort.active) {
        case 'name': return this.accountService.compare(a.name, b.name, isAsc);
        case 'is_suspended': return this.accountService.compare(a.is_suspended, b.is_suspended, isAsc);

        default: return 0;
      }
    });
  }




  suspendAssets(id: string, name: string, isSuspended: number) {
    var is_suspended;
    var _text = "";
    if (isSuspended == 1) {
      is_suspended = 0;
      _text = "unsuspend"
    } else {
      is_suspended = 1;
      _text = "suspend"
    }

    this.confirmDialogService.confirmThis('Are you sure you want to ' + _text + ' ' + name + '?', () => {

      this.isLoading = true;
      this.accountService.suspendAssets(id, is_suspended)
        .pipe(first())
        .subscribe(
          (response) => {
            this.isLoading = false;
            this.reloadAssetsLists();
          },
          (error) => {
            this.isLoading = false;
          }
        );
    }, () => {

    });

  }


  deleteAssets(id: string, name: string) {
    this.confirmDialogService.confirmThis('Are you sure you want to delete ' + name + '?. On deleting the floor all Instore and Hoarding belongs to ' + name + ' will also get deleted', () => {

      this.isLoading = true;
      this.accountService.deleteAssets(id, 1)
        .pipe(first())
        .subscribe(
          (response) => {
            this.isLoading = false;
            this.reloadAssetsLists();
          },
          (error) => {
            this.isLoading = false;
          }
        );
    }, () => {

    });
  }

  addNewAssets() {
    this.assetsForm.reset();
    this.isAddAssets = true;
  }


  /* *************  ASSETS  ************* */




  /* *************  CREATIVES  ************* */

  CreativeDataLists;
  UpdateCreativeData;
  sortedCreativeData;

  creativeSubmitted = false;
  get f4() { return this.creativeForm.controls; }

  onCreativeSubmit() {
    this.creativeSubmitted = true;
    var str_Creative = this.f4.name.value.trim();
    if (this.creativeForm.invalid) {
      return;
    }
    if (this.isAddCreative) {
      this.accountService.addCreative(str_Creative)
        .pipe(first())
        .subscribe(
          (response) => {
            this.isLoading = false;
            if (response.state === "ERROR") {
              this.toastr.error("The creative " + str_Creative + " already exists", "Error", { timeOut: 1000 });
            } else {
              this.toastr.success("The creative " + str_Creative + " added successfully", "Success", { timeOut: 1000 });
              this.reloadCreativeLists();
            }
          },
          (error) => {
            this.isLoading = false;
          }
        );
    } else {
      this.isLoading = true;
      this.accountService.updateCreative(this.UpdateCreativeData.id, str_Creative)
        .pipe(first())
        .subscribe(
          (response) => {
            this.isLoading = false;
            if (response.state === "ERROR") {
              this.toastr.error("The creative " + str_Creative + " already exists", "Error", { timeOut: 1000 });
            } else {
              this.toastr.success("The creative " + str_Creative + " updated successfully", "Success", { timeOut: 1000 });
              this.reloadCreativeLists();
            }
          },
          (error) => {
            this.isLoading = false;
          }
        );
      this.isAddCreative = true;
    }
  }

  reloadCreativeLists() {
    this.accountService.getCreativeLists()
      .pipe(first())
      .subscribe(
        (response) => {
          this.isLoading = false;
          this.CreativeDataLists = response.result;
          this.sortedCreativeData = response.result;
        },
        (error) => {
          this.isLoading = false;
        }
      );
    this.onReset();
  }

  editCreative(id: string) {
    this.creativeForm.reset();
    this.isAddCreative = false;
    this.UpdateCreativeData = this.CreativeDataLists.find(x => x.id === id);
    this.creativeForm.controls.name.setValue(this.UpdateCreativeData.name);
  }

  sortCreativeData(sort: Sort) {
    const data = this.CreativeDataLists.slice();
    if (!sort.active || sort.direction == '') {
      this.sortedCreativeData = data;
      return;
    }

    this.sortedCreativeData = data.sort((a, b) => {
      let isAsc = sort.direction == 'asc';
      switch (sort.active) {
        case 'name': return this.accountService.compare(a.name, b.name, isAsc);
        case 'is_suspended': return this.accountService.compare(a.is_suspended, b.is_suspended, isAsc);
        default: return 0;
      }
    });
  }

  suspendCreative(id: string, name: string, isSuspended: number) {
    var is_suspended;
    var _text = "";
    if (isSuspended == 1) {
      is_suspended = 0;
      _text = "unsuspend"
    } else {
      is_suspended = 1;
      _text = "suspend"
    }

    this.confirmDialogService.confirmThis('Are you sure you want to ' + _text + ' ' + name + '?', () => {

      this.isLoading = true;
      this.accountService.suspendCreative(id, is_suspended)
        .pipe(first())
        .subscribe(
          (response) => {
            this.isLoading = false;
            this.reloadCreativeLists();
          },
          (error) => {
            this.isLoading = false;
          }
        );
    }, () => {

    });
  }


  deleteCreative(id: string, name: string) {
    this.confirmDialogService.confirmThis('Are you sure you want to delete ' + name + '?. On deleting the floor all Instore and Hoarding belongs to ' + name + ' will also get deleted', () => {

      this.isLoading = true;
      this.accountService.deleteCreative(id, 1)
        .pipe(first())
        .subscribe(
          (response) => {
            this.isLoading = false;
            this.reloadCreativeLists();
          },
          (error) => {
            this.isLoading = false;
          }
        );
    }, () => {

    });
  }


  addNewCreative() {
    this.creativeForm.reset();
    this.isAddCreative = true;
  }


  /* *************  CREATIVES  ************* */



  /* *************  floors  ************* */

  FloorDataLists;
  sortedFloorData;
  UpdateFloorData;

  floorSubmitted = false;
  get f_floor() { return this.floorForm.controls; }

  onFloorSubmit() {
    this.floorSubmitted = true;
    var strFloorName = this.f_floor.name.value.trim();;
    if (this.floorForm.invalid) {
      return;
    }
    if (this.isAddFloor) {
      this.accountService.addFloor(strFloorName)
        .pipe(first())
        .subscribe(
          (response) => {
            this.isLoading = false;
            if (response.state === "ERROR") {
              this.toastr.error("The floor " + strFloorName + " already exists", "Error", { timeOut: 1000 });
            } else {
              this.toastr.success("The floor " + strFloorName + " added successfully", "Success", { timeOut: 1000 });
              this.reloadAllFloorLists();
            }
          },
          (error) => {
            this.isLoading = false;
          }
        );
    } else {
      this.isLoading = true;
      this.accountService.updateFloor(this.UpdateFloorData.id, strFloorName)
        .pipe(first())
        .subscribe(
          (response) => {
            this.isLoading = false;
            if (response.state === "ERROR") {
              this.toastr.error("The floor " + strFloorName + " already exists", "Error", { timeOut: 1000 });
            } else {
              this.toastr.success("The floor " + strFloorName + " updated successfully", "Success", { timeOut: 1000 });
              this.reloadAllFloorLists();
            }
          },
          (error) => {
            this.isLoading = false;
          }
        );
      this.isAddFloor = true;
    }
  }
  reloadAllFloorLists() {
    this.accountService.getFloorLists()
      .pipe(first())
      .subscribe(
        (response) => {
          this.isLoading = false;
          this.FloorDataLists = response.result;
          this.FloorDataLists.map(i => i.isSelected = false)
          this.sortedFloorData = this.FloorDataLists;
        },
        (error) => {
          this.isLoading = false;
        }
      );
    this.onReset();
  }





  FloorMappingDataLists;
  sortedMappingFloorData;
  UpdateMappingFloorData;

  getFloorMappingLists() {
    this.accountService.getFloorMappingsLists()
      .pipe(first())
      .subscribe(
        (response) => {
          this.isLoading = false;
          this.FloorMappingDataLists = response.result;
          //console.log(JSON.stringify(this.sortedMappingFloorData));
          this.sortedMappingFloorData = this.FloorMappingDataLists;

        },
        (error) => {
          this.isLoading = false;
        }
      );
    this.onReset();


  }
  editFloor(id: string) {
    this.floorForm.reset();
    this.isAddFloor = false;
    this.UpdateFloorData = this.FloorDataLists.find(x => x.id === id);
    this.floorForm.controls.name.setValue(this.UpdateFloorData.name);
    //  this.floorForm.controls.code.setValue(this.UpdateFloorData.code);
  }

  getFloorName(ids) {
    var floorList = [];
    var str_array = ids.split(',');
    // for(var i = 0; i < str_array.length; i++) {
    //   str_array[i] = str_array[i].replace(/^\s*/, "").replace(/\s*$/, "");
    //   var floorName = this.FloorDataLists.filter(x => x.id === parseInt(str_array[i]))[0].name;
    //   floorList.push(floorName)
    //   }

    for (var i = 0; i < str_array.length; i++) {
      str_array[i] = str_array[i].replace(/^\s*/, "").replace(/\s*$/, "");
      for (let j = 0; j < this.FloorDataLists.length; j++) {
        if (this.FloorDataLists[j].id === parseInt(str_array[i])) {
          var floorName = this.FloorDataLists[j].name;
          floorList.push(floorName)
        }
      }
    }
    return floorList;
  }

  sortFloorData(sort: Sort) {
    const data = this.FloorDataLists.slice();
    if (!sort.active || sort.direction == '') {
      this.sortedFloorData = data;
      return;
    }

    this.sortedFloorData = data.sort((a, b) => {
      let isAsc = sort.direction == 'asc';
      switch (sort.active) {
        case 'name': return this.accountService.compare(a.name, b.name, isAsc);
        case 'is_suspended': return this.accountService.compare(a.is_suspended, b.is_suspended, isAsc);

        default: return 0;
      }
    });
  }
  sortFloorMapping(sort: Sort) {
    const data = this.FloorMappingDataLists.slice();
    if (!sort.active || sort.direction == '') {
      this.sortedMappingFloorData = data;
      return;
    }

    this.sortedMappingFloorData = data.sort((a, b) => {
      let isAsc = sort.direction == 'asc';
      switch (sort.active) {
        case 'region_name': return this.accountService.compare(a.region_name, b.region_name, isAsc);
        case 'showroom_name': return this.accountService.compare(a.showroom_name, b.showroom_name, isAsc);
        default: return 0;
      }
    });
  }
  suspendFloor(id: string, name: string, isSuspended: number) {
    var is_suspended;
    var _text = "";
    if (isSuspended == 1) {
      is_suspended = 0;
      _text = "unsuspend"
    } else {
      is_suspended = 1;
      _text = "suspend"
    }

    this.confirmDialogService.confirmThis('Are you sure you want to ' + _text + ' ' + name + '?', () => {

      this.isLoading = true;
      this.accountService.suspendFloor(id, is_suspended)
        .pipe(first())
        .subscribe(
          (response) => {
            this.isLoading = false;
            this.reloadAllFloorLists();
          },
          (error) => {
            this.isLoading = false;
          }
        );
    }, () => {

    });

  }
  deleteFloor(id: string, name: string) {

    this.confirmDialogService.confirmThis('Are you sure you want to delete ' + name + '?. On deleting the floor all Instore and Hoarding belongs to ' + name + ' will also get deleted', () => {

      this.isLoading = true;
      this.accountService.deleteFloor(id, 1)
        .pipe(first())
        .subscribe(
          (response) => {
            this.isLoading = false;
            this.reloadAllFloorLists();
          },
          (error) => {
            this.isLoading = false;
          }
        );
    }, () => {

    });

  }
  addNewFloor() {
    this.floorForm.reset();
    this.isAddFloor = true;
    this.isShowAddFloor = false;
  }
  mapFloor() {
    this.isShowAddFloor = true;
  }
  setChecked(id: number) {
    for (let i = 0; i < this.FloorDataLists.length; i++) {
      if (this.FloorDataLists[i].id === id) {
        if (this.FloorDataLists[i].isSelected) {
          this.FloorDataLists[i].isSelected = false;
        } else {
          this.FloorDataLists[i].isSelected = true;
        }
      }
    }
  }

  floorMappingSubmitted = false;
  get f_m_floor() { return this.floorMappingForm.controls }

  onFloorMappingSubmit() {
    var selectedFloors = [];
    this.floorMappingSubmitted = true;
    if (this.floorMappingForm.invalid) {
      return;
    }
    for (let i = 0; i < this.FloorDataLists.length; i++) {
      if (this.FloorDataLists[i].isSelected) {
        selectedFloors.push(this.FloorDataLists[i].id)
      }
    }
    if (selectedFloors.length > 0) {
      this.accountService.addFloorMapping(this.f_m_floor.region_id.value, this.f_m_floor.showroom_id.value, selectedFloors)
        .pipe(first())
        .subscribe(
          (response) => {
            this.isLoading = false;
            this.FloorDataLists.map(i => i.isSelected = false)
            this.getFloorMappingLists();
          },
          (error) => {
            this.isLoading = false;
          }
        );
    } else {
      this.toastr.warning("Please select floors", "Alert !",);

    }
  }

  /* *************  floors  ************* */

  /* *************  locations  ************* */

  // Create an object to push into the array
  selectallObj = {
    name: 'Select All',
    id: 0,
    isSelected: false,
    created_by: 1,
    is_deleted: 0,
    is_suspended: 0
  };
  LocationDataLists;
  filterLocationList;
  sortedLocationData;
  UpdateLocationData;

  locationSubmitted = false;
  locationMappingSubmitted = false;
  locationMappingSubmittedright = false;
  get f_location() { return this.locationForm.controls; }
  get loc_map_form() { return this.locationMappingForm.controls; }

  onLocationSubmit() {
    this.locationSubmitted = true;
    var strLocationName = this.f_location.name.value.trim();
    if (this.locationForm.invalid) {
      return;
    }
    if (this.isAddLocation) {

      this.accountService.addLocation(strLocationName)
        .pipe(first())
        .subscribe(
          (response) => {
            this.isLoading = false;
            if (response.state === "ERROR") {
              this.toastr.error("The location " + strLocationName + " already exists", "Error", { timeOut: 1000 });
            } else {
              this.toastr.success("The location " + strLocationName + " added successfully", "Success", { timeOut: 1000 });

              this.reloadLocationLists();
            }
          },
          (error) => {
            this.isLoading = false;

          }
        );
    } else {
      this.isLoading = true;
      this.accountService.updateLocation(this.UpdateLocationData.id, strLocationName)
        .pipe(first())
        .subscribe(
          (response) => {
            this.isLoading = false;
            debugger;
            if (response.state === "ERROR") {
              this.toastr.error("The location " + strLocationName + " already exists", "Error", { timeOut: 1000 });
            } else {
              this.toastr.success("The location " + strLocationName + " updated successfully", "Success", { timeOut: 1000 });
              this.reloadLocationLists();
            }
          },
          (error) => {
            this.isLoading = false;
          }
        );
      this.isAddLocation = true;
    }
  }

  reloadLocationLists() {
    this.accountService.getLocationLists()
      .pipe(first())
      .subscribe(
        (response) => {
          this.isLoading = false;
          this.LocationDataLists = response.result;
          this.LocationDataLists.unshift(this.selectallObj);
          this.LocationDataLists.map(i => i.isSelected = false)
          this.sortedLocationData = this.LocationDataLists;
          this.filterLocationList = this.LocationDataLists;
        },
        (error) => {
          this.isLoading = false;
        }
      );

    this.onReset();
  }

  LocationMappingDataLists = [];

  onLocationMappingSubmit() {
    var selectedLocations = [];
    this.locationMappingSubmitted = true;
    this.locationMappingSubmittedright = true;
    if (this.locationMappingForm.invalid) {
      return;
    }
    // var prevfilterLocationList = this.filterLocationList
    for (let i = 0; i < this.LocationDataLists.length; i++) {
      if (this.LocationDataLists[i].isSelected) {
        debugger;
        selectedLocations.push(this.LocationDataLists[i].id)
      }
    }
    if (selectedLocations.length > 0) {
      this.accountService.addLocationMapping(this.loc_map_form.region_id.value, this.loc_map_form.showroom_id.value, this.loc_map_form.floor_id.value, selectedLocations)
        .pipe(first())
        .subscribe(
          (response) => {
            debugger;
            this.isLoading = false;
            this.filterLocationList.map(i => i.isSelected = false)
            this.getLocationMappingLists();
            this.filterString = '';
          },
          (error) => {
            this.isLoading = false;
          }
        );

    } else {
      this.toastr.warning("Please select Locations", "Alert !",);
    }

  }

  setLocationChecked(id: number) {
    if (id === 0) {
      this.filterLocationList[0].isSelected = !this.filterLocationList[0].isSelected;
      for (let i = 0; i < this.filterLocationList.length; i++) {
        this.filterLocationList[i].isSelected = this.filterLocationList[0].isSelected;
      }
    } else {
      for (let i = 0; i < this.filterLocationList.length; i++) {
        if (this.filterLocationList[i].id === id) {
          if (this.filterLocationList[i].isSelected) {
            this.filterLocationList[i].isSelected = false;
            this.filterLocationList[0].isSelected = false;
          } else {
            let isSelectAllChecked = this.LocationDataLists.filter(x => x.isSelected === true);
            if (isSelectAllChecked.length == this.filterLocationList.length - 2 && !this.filterLocationList[i].isSelected) {
              this.filterLocationList[0].isSelected = true;
            }
            this.filterLocationList[i].isSelected = true;
          }
        }
      }
    }
  }

  locationRegionID;
  locationRegionIDF;
  location_f_showroomLists;
  onFilterRegionChange(regionID) {
    this.locationRegionIDF = regionID;
    this.location_f_showroomLists = this.ShowroomDataLists.filter(s => s.region_id === parseInt(regionID, 10));
  }


  locationShowroomIDF;
  locationShowroomID;
  location_f_FloorLists;
  onFilterShowroomChange(showroomID) {
    this.locationShowroomIDF = showroomID;
    this.instoreService.getFloorLists(showroomID)
      .pipe(first())
      .subscribe(
        (response) => {
          this.isLoading = false;
          this.location_f_FloorLists = response.result;
        },
        (error) => {
          this.isLoading = false;
        }
      );
  }
  loc_map_floorID;;
  loc_map_floorIDF;;
  onFilterFloorChange(floorID) {
    debugger;
    this.locationMappingSubmittedright = false;
    this.loc_map_floorIDF = floorID;
    this.getLocationMappingListsFront();

  }
  onFloorSelectionChange(floorID) {
    this.loc_map_floorID = floorID;
  }

  getLocationName(ids) {
    var locationList = [];
    var str_array = ids.split(',');
    for (var i = 0; i < str_array.length; i++) {
      str_array[i] = str_array[i].replace(/^\s*/, "").replace(/\s*$/, "");
      for (let j = 0; j < this.LocationDataLists.length; j++) {
        if (this.LocationDataLists[j].id === parseInt(str_array[i])) {
          var locationName = this.LocationDataLists[j].name;
          locationList.push(locationName)
        }
      }
    }
    return locationList;
  }

  getLocationMappingLists() {
    this.accountService.getLocationMappingLists(this.locationRegionID, this.locationShowroomID, this.loc_map_floorID)
      .pipe(first())
      .subscribe(
        (response) => {
          this.isLoading = false; console.log(JSON.stringify(this.LocationMappingDataLists));

          this.LocationMappingDataLists = response.result;
        },
        (error) => {
          this.isLoading = false;
        }
      );
    this.onReset();
  }

  getLocationMappingListsFront() {
    this.accountService.getLocationMappingLists(this.locationRegionIDF, this.locationShowroomIDF, this.loc_map_floorIDF)
      .pipe(first())
      .subscribe(
        (response) => {
          this.isLoading = false; console.log(JSON.stringify(this.LocationMappingDataLists));

          this.LocationMappingDataLists = response.result;
        },
        (error) => {
          this.isLoading = false;
        }
      );
    this.onReset();
  }



  editLocation(id: string) {
    this.locationForm.reset();
    this.isAddLocation = false;
    this.UpdateLocationData = this.LocationDataLists.find(x => x.id === id);
    this.locationForm.controls.name.setValue(this.UpdateLocationData.name);
  }
  sortLocationData(sort: Sort) {
    const data = this.LocationDataLists.slice();
    if (!sort.active || sort.direction == '') {
      this.sortedLocationData = data;
      return;
    }

    this.sortedLocationData = data.sort((a, b) => {
      let isAsc = sort.direction == 'asc';
      switch (sort.active) {
        case 'name': return this.accountService.compare(a.name, b.name, isAsc);
        case 'is_suspended': return this.accountService.compare(a.is_suspended, b.is_suspended, isAsc);

        default: return 0;
      }
    });
  }
  suspendLocation(id: string, name: string, isSuspended: number) {
    var is_suspended;
    var _text = "";
    if (isSuspended == 1) {
      is_suspended = 0;
      _text = "unsuspend"
    } else {
      is_suspended = 1;
      _text = "suspend"
    }

    this.confirmDialogService.confirmThis('Are you sure you want to ' + _text + ' ' + name + '?', () => {

      this.isLoading = true;
      this.accountService.suspendLocation(id, is_suspended)
        .pipe(first())
        .subscribe(
          (response) => {
            this.isLoading = false;
            this.reloadLocationLists();
          },
          (error) => {
            this.isLoading = false;
          }
        );
    }, () => {

    });


  }
  deleteLocation(id: string, name: string) {
    this.confirmDialogService.confirmThis('Are you sure you want to delete ' + name + '?. On deleting the floor all Instore and Hoarding belongs to ' + name + ' will also get deleted', () => {
      this.isLoading = true;
      this.accountService.deleteLocation(id, 1)
        .pipe(first())
        .subscribe(
          (response) => {
            this.isLoading = false;
            this.reloadLocationLists();
          },
          (error) => {
            this.isLoading = false;
          }
        );
    }, () => {

    });
  }

  addNewLocation() {
    this.locationForm.reset();
    this.isAddLocation = true;
    this.isShowAddLocation = true;
  }
  mapLocation() {
    this.isShowAddLocation = false;
  }
  /* *************  locations  ************* */


  /* *************  campaign  ************* */
  campaignSubmitted = false;
  campaignMappingSubmitted = false;
  campaignDataLists;
  // sortedCampaignLists;
  campaignMappingDataLists;
  UpdateCampaignData;
  campaignRegionID;
  campaignShowroomID;
  get f_campaign() { return this.campaignForm.controls; }
  get f11() { return this.campaignMappingForm.controls; }

  // sortCampaignData(sort: Sort) {
  //   const data = this.campaignDataLists.slice();
  //   if (!sort.active || sort.direction == '') {
  //     this.sortedCampaignLists = data;
  //     return;
  //   }

  //   this.sortedCampaignLists = data.sort((a, b) => {
  //     let isAsc = sort.direction == 'asc';
  //     switch (sort.active) {
  //       case 'name': return this.accountService.compare(a.name, b.name, isAsc);

  //       default: return 0;
  //     }
  //   });
  // }
  // reloadCampaignLists(){
  //   this.isLoading = true;

  //   this.accountService.getFestivalLists()
  //   .pipe(first())
  //     .subscribe(
  //     (response) => {
  //       this.isLoading = false;
  //       this.campaignDataLists = response.result;
  //       this.campaignDataLists.map(i=>i.isSelected=false)
  //       this.sortedCampaignLists = response.result
  //         .map((recog, i) => ({id: i + 1, ...recog}))
  //         .slice((this.page - 1) * this.pageSize, (this.page - 1) * this.pageSize + this.pageSize);

  //     },
  //   (error) => {     
  //     this.isLoading = false;                               
  //   }
  //   );
  //   this.onReset();
  // }
  startDateChange(event) {
    if (event.value) {
      //console.log("Date of Birth: " + moment(event.value).format(this.format) );
      //this.selInstallDate =  moment(event.value).format(this.format);
      //this.filterForInstore()
      this.minDate = event.value;
      this.resetExpiry();

    } else {
      //this.selInstallDate = "";
      //this.filterForInstore()
    }
  }

  resetExpiry() {
    this.campaignForm.patchValue({
      end_date: ''
    });
  }

  editCampaign(id: string) {
    this.campaignForm.reset();
    this.isAddCampaign = false;
    this.UpdateCampaignData = this.campaignDataLists.find(x => x.id === id);
    this.campaignForm.controls.name.setValue(this.UpdateCampaignData.name);
    this.campaignForm.controls.start_date.setValue(this.UpdateCampaignData.start_date);
    this.campaignForm.controls.end_date.setValue(this.UpdateCampaignData.end_date);
  }
  //   suspendCampaign(id: string,isSuspended:number){
  //     var is_suspended;
  //     if(isSuspended==1){
  //       is_suspended = 0;
  //     }else{
  //       is_suspended = 1;
  //     }       
  //     this.isLoading = true;
  //       this.accountService.suspendCampaign(id,is_suspended)
  //       .pipe(first())
  //       .subscribe(
  //       (response) => {
  //         this.isLoading = false;
  //         this.reloadCampaignLists();
  //       },
  //       (error) => {        
  //         this.isLoading = false;
  //       }
  //     );  
  //   }


  //   deleteCampaign(id: string){
  //     this.isLoading = true;
  //     this.accountService.deleteCampaign(id,1)
  //     .pipe(first())
  //         .subscribe(
  //         (response) => {
  //           this.isLoading = false;
  //           this.reloadCampaignLists();
  //         },
  //         (error) => {        
  //           this.isLoading = false;
  //         }
  //       );  
  //    }
  //    getCampaignName(ids){
  //     var campaignLists=[];
  //     var str_array = ids.split(',');
  //     for(var i = 0; i < str_array.length; i++) {
  //       str_array[i] = str_array[i].replace(/^\s*/, "").replace(/\s*$/, "");
  //       for (let j = 0; j < this.campaignDataLists.length; j++) {
  //         if(this.campaignDataLists[j].id ===  parseInt(str_array[i])){
  //           var campaignName = this.campaignDataLists[j].name;
  //           campaignLists.push(campaignName)
  //         }
  //       }         
  //     }
  //     return campaignLists;
  //  }
  //   onCampaignSubmit(){
  //     this.campaignSubmitted = true;
  //     if (this.campaignForm.invalid) {
  //       return;
  //     }
  //     if(this.isAddCampaign){

  //       this.campaignForm.get("end_date").setValue(moment(this.f_campaign.end_date.value).format(this.format)); //Working
  //       this.campaignForm.get("start_date").setValue(moment(this.f_campaign.start_date.value).format(this.format)); //Working


  //       const formDataNew = new FormData();   
  //       formDataNew.append('name', this.campaignForm.get('name').value);
  //       formDataNew.append('start_date', this.campaignForm.get('start_date').value);
  //       formDataNew.append('end_date', this.campaignForm.get('end_date').value);

  //       this.accountService.addCampaign(formDataNew)
  //         .pipe(first())
  //         .subscribe(
  //         (response) => {
  //           this.isLoading = false;
  //           this.reloadCampaignLists();
  //           this.campaignForm.reset();
  //         },
  //         (error) => {        
  //           this.isLoading = false;
  //         }
  //       ); 
  //     }else{
  //       this.isLoading = true;

  //       this.campaignForm.get("end_date").setValue(moment(this.f_campaign.end_date.value).format(this.format)); //Working
  //       this.campaignForm.get("start_date").setValue(moment(this.f_campaign.start_date.value).format(this.format)); //Working


  //       const formDataNew = new FormData();   
  //       formDataNew.append('festival_id',this.UpdateCampaignData.id);
  //       formDataNew.append('name', this.campaignForm.get('name').value);
  //       formDataNew.append('start_date', this.campaignForm.get('start_date').value);
  //       formDataNew.append('end_date', this.campaignForm.get('end_date').value);


  //       this.accountService.updateCampaign(formDataNew)
  //         .pipe(first())
  //         .subscribe(
  //         (response) => {
  //           this.isLoading = false;
  //           this.reloadCampaignLists();
  //           this.campaignForm.reset();
  //         },
  //         (error) => {        
  //           this.isLoading = false;
  //         }
  //       );
  //       this.isAddCampaign= true; 
  //     }
  //   }
  //   setCampaignChecked(id:number){
  //     for (let i = 0; i < this.campaignDataLists.length; i++) {
  //       if(this.campaignDataLists[i].id===id){
  //         if(this.campaignDataLists[i].isSelected){
  //           this.campaignDataLists[i].isSelected = false;
  //         }else{
  //           this.campaignDataLists[i].isSelected = true;
  //         }
  //       }
  //     }
  //    }

  //    onCampaignMappingSubmit(){
  //     var seletedCampaigns=[];
  //     this.campaignMappingSubmitted = true;

  //     if (this.campaignMappingForm.invalid) {
  //       return;
  //     }
  //     for (let i = 0; i < this.campaignDataLists.length; i++) {
  //       if(this.campaignDataLists[i].isSelected){
  //         seletedCampaigns.push(this.campaignDataLists[i].id)
  //       }
  //     }
  //     this.accountService.addCamapignMapping(this.f11.region_id.value,this.f11.showroom_id.value,seletedCampaigns)
  //       .pipe(first())
  //       .subscribe(
  //       (response) => {
  //         this.isLoading = false;
  //         this.getCampaignMappingLists();

  //       },
  //       (error) => {        
  //         this.isLoading = false;
  //       }
  //     ); 
  //    }
  //    getCampaignMappingLists(){
  //     this.accountService.getCampaignMappingLists(this.campaignRegionID, this.campaignShowroomID)
  //     .pipe(first())
  //       .subscribe(
  //       (response) => {
  //         this.isLoading = false;
  //         this.campaignMappingDataLists = response.result;  
  //       },
  //     (error) => {     
  //       this.isLoading = false;                               
  //     }
  //     );
  //     this.onReset();
  //   }


  //   campaign_f_showroomLists;
  //   r_onCampaignFilter(regionID) {
  //     this.campaignRegionID = regionID;
  //     this.campaign_f_showroomLists = this.ShowroomDataLists.filter(s => s.region_id === parseInt(regionID, 10));
  //   }
  //   s_onCampaignFilter(showroomID){
  //       this.campaignShowroomID = showroomID;
  //       this.getCampaignMappingLists();
  //   }





  /* *************  campaign  ************* */
  /* *************  ASSETS  ************* */




  /* *************  VENDOR  ************* */

  VendorDataLists;
  UpdateVendorData;
  sortedVendorData;




  vendorSubmitted = false;
  get fVendor() { return this.vendorForm.controls; }

  onVendorSubmit() {
    this.vendorSubmitted = true;
    var strVendor = this.fVendor.name.value.trim();
    if (this.vendorForm.invalid) {
      return;
    }
    if (this.isAddVendor) {

      this.accountService.addVendor(strVendor)
        .pipe(first())
        .subscribe(
          (response) => {
            this.isLoading = false;

            if (response.state === "ERROR") {
              this.toastr.error("The vendor " + strVendor + " already exists", "Error", { timeOut: 1000 });
            } else {
              this.toastr.success("The vendor " + strVendor + " added successfully", "Success", { timeOut: 1000 });
              this.reloadVendorLists();
            }
          },
          (error) => {
            this.isLoading = false;
          }
        );
    } else {
      this.isLoading = true;
      this.accountService.updateVendor(this.UpdateVendorData.id, this.fVendor.name.value)
        .pipe(first())
        .subscribe(
          (response) => {
            this.isLoading = false;
            if (response.state === "ERROR") {
              this.toastr.error("The vendor " + strVendor + " already exists", "Error", { timeOut: 1000 });
            } else {
              this.toastr.success("The vendor " + strVendor + " updated successfully", "Success", { timeOut: 1000 });
              this.reloadVendorLists();
            }
          },
          (error) => {
            this.isLoading = false;
          }
        );
      this.isAddVendor = true;
    }
  }

  reloadVendorLists() {
    this.accountService.getVendorLists()
      .pipe(first())
      .subscribe(
        (response) => {
          this.isLoading = false;
          this.VendorDataLists = response.result;
          this.sortedVendorData = this.VendorDataLists.slice();
        },
        (error) => {
          this.isLoading = false;
        }
      );
    this.onReset();
  }

  editVendor(id: string) {
    this.vendorForm.reset();
    this.isAddVendor = false;
    this.UpdateVendorData = this.VendorDataLists.find(x => x.id === id);
    this.vendorForm.controls.name.setValue(this.UpdateVendorData.name);
  }

  sortVendorData(sort: Sort) {
    const data = this.VendorDataLists.slice();
    if (!sort.active || sort.direction == '') {
      this.sortedVendorData = data;
      return;
    }

    this.sortedVendorData = data.sort((a, b) => {
      let isAsc = sort.direction == 'asc';
      switch (sort.active) {
        case 'name': return this.accountService.compare(a.name, b.name, isAsc);
        case 'is_suspended': return this.accountService.compare(a.is_suspended, b.is_suspended, isAsc);
        default: return 0;
      }
    });
  }

  addNewVendor() {
    this.vendorForm.reset();
    this.isAddVendor = true;
  }

  suspendVendor(id: string, name: string, isSuspended: number) {
    var is_suspended;
    var _text = "";
    if (isSuspended == 1) {
      is_suspended = 0;
      _text = "unsuspend"
    } else {
      is_suspended = 1;
      _text = "suspend"
    }

    this.confirmDialogService.confirmThis('Are you sure you want to ' + _text + ' ' + name + '?', () => {

      this.isLoading = true;
      this.accountService.suspendVendor(id, is_suspended)
        .pipe(first())
        .subscribe(
          (response) => {
            this.isLoading = false;
            this.reloadVendorLists();
          },
          (error) => {
            this.isLoading = false;
          }
        );
    }, () => {

    });
  }


  deleteVendor(id: string, name: string) {

    this.confirmDialogService.confirmThis('Are you sure you want to delete ' + name + '?. On deleting the floor all Instore and Hoarding belongs to ' + name + ' will also get deleted', () => {

      this.isLoading = true;
      this.accountService.deleteVendor(id, 1)
        .pipe(first())
        .subscribe(
          (response) => {
            this.isLoading = false;
            this.reloadVendorLists();
          },
          (error) => {
            this.isLoading = false;
          }
        );
    }, () => {

    });
  }

  /* *************  VENDOR  ************* */


  isAddFestival = true;
  isSelectAll = false;

  /* *************  TEXT FILTERING  ************* */
  filterString = "";
  onFilterChange(type: string, searchText: string = "") {
    if (type === 'user') {
      var tempList = this.UserDataLists.filter((invoice) => this.isMatch(invoice));
      this.sortedUserData = tempList
      // .map((recog, i) => ({id: i + 1, ...recog}))
      // .slice((this.page - 1) * this.pageSize, (this.page - 1) * this.pageSize + this.pageSize);
    } else if (type === 'region') {
      var tempListR = this.RegionDataLists.filter((invoice) => this.isMatch(invoice));
      this.sortedRegionData = tempListR
      // .map((recog, i) => ({id: i + 1, ...recog}))
      // .slice((this.page - 1) * this.pageSize, (this.page - 1) * this.pageSize + this.pageSize);
    } else if (type === 'showroom') {
      var tempListS = this.ShowroomDataLists.filter((invoice) => this.isMatch(invoice));
      this.sortedShowroomData = tempListS
      // .map((recog, i) => ({id: i + 1, ...recog}))
      // .slice((this.page - 1) * this.pageSize, (this.page - 1) * this.pageSize + this.pageSize);
    } else if (type === 'assets') {
      var tempListA = this.AssetsDataLists.filter((invoice) => this.isMatch(invoice));
      this.sortedAssetsData = tempListA
      // .map((recog, i) => ({id: i + 1, ...recog}))
      // .slice((this.page - 1) * this.pageSize, (this.page - 1) * this.pageSize + this.pageSize);
    } else if (type === 'creative') {
      var tempListC = this.CreativeDataLists.filter((invoice) => this.isMatch(invoice));
      this.sortedCreativeData = tempListC
      // .map((recog, i) => ({id: i + 1, ...recog}))
      // .slice((this.page - 1) * this.pageSize, (this.page - 1) * this.pageSize + this.pageSize);
    } else if (type === 'vendor') {
      var tempListV = this.VendorDataLists.filter((invoice) => this.isMatch(invoice));
      this.sortedVendorData = tempListV
      // .map((recog, i) => ({id: i + 1, ...recog}))
      // .slice((this.page - 1) * this.pageSize, (this.page - 1) * this.pageSize + this.pageSize);
    } else if (type === 'floor') {
      var tempListF = this.FloorDataLists.filter((invoice) => this.isMatch(invoice));
      this.sortedFloorData = tempListF
      // .map((recog, i) => ({id: i + 1, ...recog}))
      // .slice((this.page - 1) * this.pageSize, (this.page - 1) * this.pageSize + this.pageSize);
    } else if (type === 'location') {
      var tempListL = this.LocationDataLists.filter((invoice) => this.isMatch(invoice));
      this.sortedLocationData = tempListL;
    }
    else if (type === 'floorMapping') {
      var tempListFM = this.FloorMappingDataLists.filter((invoice) => this.isMatch(invoice));
      this.sortedMappingFloorData = tempListFM
      // .map((recog, i) => ({id: i + 1, ...recog}))
      // .slice((this.page - 1) * this.pageSize, (this.page - 1) * this.pageSize + this.pageSize);
    }
    else if (type === 'campaign') {
      // var tempListCampaign = this.campaignDataLists.filter((invoice) => this.isMatch(invoice));
      // this.sortedCampaignLists = tempListCampaign
    }
    else if (type === 'locate') {
      var tempListL = this.LocationDataLists.filter((invoice) => invoice.name.toLowerCase().includes(searchText.toLowerCase()) && invoice.id !== 0);
      this.filterLocationList = tempListL;
      this.filterLocationList.unshift(this.selectallObj);
      this.filterString = searchText;
      // .map((recog, i) => ({id: i + 1, ...recog}))
      // .slice((this.page - 1) * this.pageSize, (this.page - 1) * this.pageSize + this.pageSize);
    }
  }

  isMatch(item) {
    if (!this.filterString) {
      // If the filterString is empty, return the whole table data
      return true;
    }

    if (item instanceof Object) {
      return Object.keys(item).some(k => this.isMatch(item[k]));
    } else if (typeof item === 'string' && this.filterString) {
      const lowerCaseItem = item.toLowerCase();
      const lowerCaseFilter = this.filterString.toLowerCase();
      return lowerCaseItem.includes(lowerCaseFilter);
    } else {
      return false;
    }
  }



  /* *************  TEXT FILTERING  ************* */


  open(content) {
    this.modalService.open(content, { ariaLabelledBy: 'modal-basic-title' }).result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }
  onReset() {

    this.submitted = false;
    this.regionSubmitted = false;
    this.showroomSubmitted = false;
    this.assetsSubmitted = false;
    this.creativeSubmitted = false;
    this.vendorSubmitted = false;
    this.floorSubmitted = false;
    this.floorMappingSubmitted = false;
    this.campaignSubmitted = false;
    if (this.locationMappingSubmittedright) {
      debugger;
      this.filterform.reset();
    }
    this.registerForm.reset();
    this.updateForm.reset();
    this.regionForm.reset();
    this.creativeForm.reset();
    this.assetsForm.reset();
    this.showroomForm.reset();
    this.vendorForm.reset();
    this.floorForm.reset();
    this.campaignForm.reset();
    this.floorMappingForm.reset();
    this.locationMappingForm.reset();
    this.locationForm.reset();
    this.imageSrc = null;
    this.imageShowroomSrc = null;
    this.profileImage = null;
    this.filterLocationList = this.LocationDataLists;
  }

  addNewCampaign() {
    this.campaignForm.reset();
    this.isAddCampaign = true;
    this.isShowAddCampaign = true;
  }
  mapCampaign() {
    this.isShowAddCampaign = false;
  }

  excelRegion: ExcelRegion[] = [];
  excelShowroom: ExcelShowroom[] = [];
  excelAssets: ExcelAssets[] = [];
  excelCreative: ExcelCreative[] = [];
  excelVendor: ExcelVendor[] = [];
  excelFloor: ExcelFloor[] = [];
  excelFloorM: ExcelFloorM[] = [];
  excelLocation: ExcelLocation[] = [];
  excelUserData: ExcelUser[] = [];
  /* ************  Excel ***** */
  fileName = 'ExcelSheet.xlsx';



  omit_special_char(event) {
    var k;
    k = event.charCode;  //         k = event.keyCode;  (Both can be used)
    return ((k > 64 && k < 91) || (k > 96 && k < 123) || k == 8 || k == 32 || (k >= 48 && k <= 57));
  }



  exportexcel(tableId, title) {
    if (tableId == "region-table") {

      for (var i = 0; i < this.RegionDataLists.length; i++) {
        var temp = this.RegionDataLists[i];
        let tempImport = {
          ID: (i + 1).toString(),
          REGION_NAME: temp.name,
        };
        this.excelRegion.push(tempImport);
      }
      this.excelService.exportAsExcelFile(this.excelRegion, title);
    } else if (tableId == "showroom-table") {
      console.log(" - - - -" + JSON.stringify(this.ShowroomDataLists))
      for (var i = 0; i < this.ShowroomDataLists.length; i++) {
        var temp = this.ShowroomDataLists[i];
        let tempImport1 = {
          ID: (i + 1).toString(),
          REGION_NAME: temp.regionName,
          SHOWROOM_NAME: temp.name,
        };
        this.excelShowroom.push(tempImport1);
      }
      this.excelService.exportAsExcelFile(this.excelShowroom, title);
    } else if (tableId == "asset-table") {
      for (var i = 0; i < this.AssetsDataLists.length; i++) {
        var temp = this.AssetsDataLists[i];
        let tempImport2 = {
          ID: (i + 1).toString(),
          ASSETS_NAME: temp.name,
        };
        this.excelAssets.push(tempImport2);
      }
      this.excelService.exportAsExcelFile(this.excelAssets, title);
    } else if (tableId == "creative-table") {
      for (var i = 0; i < this.CreativeDataLists.length; i++) {
        var temp = this.CreativeDataLists[i];
        let tempImport3 = {
          ID: (i + 1).toString(),
          CREATIVE_NAME: temp.name,
        };
        this.excelCreative.push(tempImport3);
      }
      this.excelService.exportAsExcelFile(this.excelCreative, title);
    } else if (tableId == "vendor-table") {
      for (var i = 0; i < this.VendorDataLists.length; i++) {
        var temp = this.VendorDataLists[i];
        let tempVendor = {
          ID: (i + 1).toString(),
          VENDOR_NAME: temp.name,
        };
        this.excelVendor.push(tempVendor);
      }
      this.excelService.exportAsExcelFile(this.excelVendor, title);
    } else if (tableId == "floor-table") {
      for (var i = 0; i < this.FloorDataLists.length; i++) {
        var temp = this.FloorDataLists[i];
        let tempFloor = {
          ID: (i + 1).toString(),
          FLOOR_NAME: temp.name,
        };
        this.excelFloor.push(tempFloor);
      }
      this.excelService.exportAsExcelFile(this.excelFloor, title);
    } else if (tableId == "floor-table") {
      for (var i = 0; i < this.FloorDataLists.length; i++) {
        var temp = this.FloorDataLists[i];
        let tempFloor = {
          ID: (i + 1).toString(),
          FLOOR_NAME: temp.name,
        };
        this.excelFloor.push(tempFloor);
      }
      this.excelService.exportAsExcelFile(this.excelFloor, title);
    } else if (tableId == "floor-mapping") {
      for (var i = 0; i < this.FloorMappingDataLists.length; i++) {
        var temp = this.FloorMappingDataLists[i];
        let tempFloor_M = {
          ID: i + 1,
          REGION_NAME: temp.region_name,
          SHOWROOM_NAME: temp.showroom_name,
          FLOOR_NAME: this.getFloorName(temp.floor_ids).toString()
        };
        this.excelFloorM.push(tempFloor_M);
      }
      this.excelService.exportAsExcelFile(this.excelFloorM, title);
    } else if (tableId == "floor-mapping") {
      for (var i = 0; i < this.FloorMappingDataLists.length; i++) {
        var temp = this.FloorMappingDataLists[i];
        let tempFloor_M = {

          REGION_NAME: temp.region_name,
          SHOWROOM_NAME: temp.showroom_name,
          FLOOR_NAME: this.getFloorName(temp.floor_ids).toString()
        };
        this.excelFloorM.push(tempFloor_M);
      }
      this.excelService.exportAsExcelFile(this.excelFloorM, title);
    } else if (tableId == "location-table") {
      for (var i = 0; i < this.LocationDataLists.length; i++) {
        var temp = this.LocationDataLists[i];
        let tempLocation = {
          ID: (i + 1).toString(),
          LOCATION_NAME: temp.name,
        };
        this.excelLocation.push(tempLocation);
      }
      this.excelService.exportAsExcelFile(this.excelLocation, title);

    } else if (tableId == "user-table") {

      for (var i = 0; i < this.UserDataLists.length; i++) {
        var temp = this.UserDataLists[i];
        let tempUserData = {
          NAME: temp.first_name + " " + temp.last_name,
          DESIGNATION: temp.roleName,
          REGION: temp.regionName,
          SHOWROOM: temp.showroomName,
          EMAIL: temp.email,
          PHONE_NUMBER: temp.mobile,
        };
        this.excelUserData.push(tempUserData);
      }
      this.excelService.exportAsExcelFile(this.excelUserData, title);
    } else {
      /* table id is passed over here */
      let element = document.getElementById(tableId);
      const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);

      const dummysheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet([]);

      const convertJs = XLSX.utils.sheet_to_json(ws)

      /* generate workbook and add the worksheet */
      const wb: XLSX.WorkBook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, dummysheet, 'Sheet1');

      //then add ur txt
      XLSX.utils.sheet_add_json(wb.Sheets.Sheet1,
        [
          { note: title },
        ],
        {
          header: ["note"],
          skipHeader: true,
          origin: "A1"
        }
      );

      XLSX.utils.sheet_add_json(wb.Sheets.Sheet1,
        convertJs,
        {
          skipHeader: false,
          origin: "A3"
        })



      /* save to file */
      XLSX.writeFile(wb, this.fileName);
    }


  }
  /* *********** Excel ******** */

}
